import { useLocation, useNavigate } from 'react-router-dom';
import MotionWrapper from '../../containers/MotionWrapper';
import { Logo, TypographyLogo } from '../../assets/icons/common';
import Entrance from '../../layouts/Entrance';
import Button from '../../components/Button';
import styles from './style.module.scss';

function Welcome() {
  const location = useLocation();
  const navigate = useNavigate();

  return (
    <Entrance>
      <MotionWrapper className={styles.wrapper}>
        <TypographyLogo width={280} height={70} />
        <span className={styles.slogan}>
          Become the Merit of your expertise. Right now, you can start qualifying for a job!
        </span>
        <Button
          type='Primary'
          text='Sign up'
          onClick={() => navigate('/signup')}
        />
        <Button
          text='Sign in'
          type='Outline-Primary'
          onClick={() => navigate('/signin', { state: { from: location?.state?.from } })}
        />
      </MotionWrapper>
    </Entrance>
  )
};

export default Welcome;
